import http from "../core/http";
const group = 'vessels';

export const getDataListRequest =  async (data) => {
    return await http.post(`${group}/get`, data).then(res => res.data).catch(http.defaultCatch);
}

export const exportDataRequest =  async (data) => {
    return await http.post(`${group}/export`, data, { responseType: 'blob' }).then(res => res.data).catch(http.defaultCatch);
}

export const isDisplayedRequest =  async (data) => {
    return await http.post(`${group}/isDisplayed`, data).then(res => res.data).catch(http.defaultCatch);
}

export const findDataRequest =  async (data) => {
    return await http.post(`${group}/find`, data).then(res => res.data).catch(http.defaultCatch);
}

export const createDataRequest =  async (data) => {
    return await http.post(`${group}/create`, data).then(res => res.data).catch(http.defaultCatch);
}

export const updateDataRequest =  async (data) => {
    return await http.post(`${group}/update`, data).then(res => res.data).catch(http.defaultCatch);
}

export const approveDataRequest =  async (data) => {
    return await http.post(`${group}/approve`, data).then(res => res.data).catch(http.defaultCatch);
}

export const approveDeletionRequest =  async (data) => {
    return await http.post(`${group}/approveDeletion`, data).then(res => res.data).catch(http.defaultCatch);
}

export const rejectDeletionRequest =  async (data) => {
    return await http.post(`${group}/rejectDeletion`, data).then(res => res.data).catch(http.defaultCatch);
}

export const rejectDataRequest =  async (data) => {
    return await http.post(`${group}/reject`, data).then(res => res.data).catch(http.defaultCatch);
}

export const deleteDataRequest =  async (data) => {
    return await http.post(`${group}/delete`, data).then(res => res.data).catch(http.defaultCatch);
}

export const getVesselTypeListRequest =  async (data) => {
	return await http.post(`${group}/getVesselTypeList`, data).then(res => res.data).catch(http.defaultCatch);
}

export const validateRegistrationRequest = async (data) => {
    return await http.post(`${group}/validateRegistration`, data).then(res => res.data).catch(http.defaultCatch);
}
